angular.module('routes.publish.PublishController', [
])

/**
 * The PublishController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class PublishController
 * @constructor
 * @module routes.publish.PublishController
 */
.controller('PublishController', [
  '$scope',
  '$state',
  '$rootScope',
  'PublishService',
  'CasesService',
  function ($scope, $state, $rootScope, PublishService, CasesService) {
    'use strict';

    $scope.state = $state;

    $scope.cases = {
      current: null,
      list: []
    };

    $scope.queue = {
      current: null,
      list: [],
      source: '',
      destination: ''
    };

    $scope.publications = {
      current: null,
      list: []
    };

    $scope.publishing = false;

    $scope.custom = {
      src: 'http://dev-dcs.pearsoncmg.com/newman/api/',
      dest: 'http://app1.dev.dcs.pearson.unicon.net/newman/api/'
    };

    $scope.env = {
      development: $rootScope.config.ENVIRONMENTS.development,
      staging: $rootScope.config.ENVIRONMENTS.staging,
      production: $rootScope.config.ENVIRONMENTS.production
    };

    $scope.builds = {};

    // what value to sort on
    $scope.sortType = 'label';
    // default sort order ascending
    $scope.sortReverse = false;
    // start with no search
    $scope.searchLabel = '';

    $scope.publish = function (caseId, source, destination) {
      var caseReference;

      $scope.publishing = true;

      caseReference = CasesService.get(caseId);

      PublishService
        .create(caseId, source, destination)
        .then(function (publishResponse) {
          var publish = {
            staging: null,
            production: null
          };

          // set to current data
          if (caseReference.content.publish) {
            publish.staging = caseReference.content.publish.staging;
            publish.production = caseReference.content.publish.production;
          }

          // overwrite staging if match
          if (destination === $scope.env.staging) {
            publish.staging = {
              id: publishResponse.id,
              completed: publishResponse.createdAt
            };
          }
          // overwrite production if match
          if (destination === $scope.env.production) {
            publish.production = {
              id: publishResponse.id,
              completed: publishResponse.createdAt
            };
          }

          // add new publication to publication list
          $scope.publications.list.push(publishResponse);

          caseReference.content.publish = publish;
          caseReference.relatives = CasesService
            .createRelative(caseReference.relatives, publishResponse);

          return CasesService
            .addRelative(caseReference, publishResponse)
            .then(function (caseResponse) {
              console.log(caseResponse);
              return defineCurrentCase();
            });
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    $scope.publishAll = function (source, destination) {
      $scope.queue.list = _.cloneDeep($scope.cases.list);
      $scope.queue.source = source;
      $scope.queue.destination = destination;
      $scope.queue.active = true;

      if (destination === $scope.env.production) {
        $scope.queue.list = _.filter($scope.queue.list, function (entry) {
          if (!entry.content.publish) {
            return false;
          }
          return entry.content.publish.staging;
        });
      }

      triggerPublish();
    };

    function triggerPublish() {
      $scope.queue.current = $scope.queue.list.shift();
      $scope.publish($scope.queue.current.id, $scope.queue.source, $scope.queue.destination);
    }

    /**
     * Defines the current case
     */
    function defineCurrentCase() {
      if ($state.params.caseId) {
        $scope.cases.current = _.cloneDeep(CasesService.get($state.params.caseId));
      }

      $scope.cases.list = _.cloneDeep(CasesService.get());

      if ($scope.queue.list.length > 0) {
        triggerPublish();
      } else {
        $scope.publishing = false;
      }
    }

    function definePublications() {
      if ($state.params.caseId) {
        // filter publications by case id
        $scope.publications.list = _
          .filter(
            PublishService.get(),
            'content.caseId',
            $scope.cases.current.id
          );

        _.forEach($scope.publications.list, function (entry) {
          entry.content.sourceLabel = _.invert($scope.env)[entry.content.source];
          entry.content.destinationLabel = _.invert($scope.env)[entry.content.destination];
        });
      }
    }

    function defineBuilds() {
      $scope.builds = PublishService.builds;

      PublishService.getBuilds();
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineCurrentCase();
      definePublications();
      defineBuilds();
    }
    initialize();
  }
]);
